import { render, staticRenderFns } from "./DocumentSelect.vue?vue&type=template&id=d7cf317a&"
import script from "./DocumentSelect.vue?vue&type=script&lang=js&"
export * from "./DocumentSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports